import styled from "styled-components/macro";

export const Container = styled.div`
  background: var(--container-color);
  border-radius: 40px;
  padding: 25px;
  padding-left: 25px;
  display: flex;
  flex-wrap: wrap;
  gap: 12px 20px;
  justify-content: space-between;
  margin-bottom: 14px;

  p {
    flex: 1 1 300px;
    min-width: 0;
    margin: 0;
    display: block;
    align-self: center;
    font-size: 16px;
    color: var(--grey-1);
    line-height: 130% !important;
    font-weight: 500;
    a {
      color: #444;
      text-decoration: underline;
    }
  }

  img {
    /* width: 150px; */
    height: 80px;
    align-self: center;
    margin-right: -12px;
  }

  button {
    margin-top: 0 !important;
    margin-left: 20px;
    align-self: center;
    min-width: 180px;
    padding: 8px 20px !important;
    white-space: nowrap;
  }

  &.sw2 {
    background: var(--menu-color);
    border-radius: 24px;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.15), 0px 0px 2px 0px rgba(0, 0, 0, 0.25);
    padding: 16px 16px 16px 19px;
    margin: 0 16px 16px 16px;
    width: auto;

    p {
      font-size: 15px;
    }

    button {
      padding: 7px 12px !important;
      border-radius: 10px !important;
      margin: 0;
      min-width: fit-content;
      border: 2px solid var(--primary-cta) !important; // so it matches the size of secondary CTA
    }
  }
`;
